/*
These functions make sure WordPress
and Foundation play nice together.
*/


var mymap;

var googlesatelite;
var googlestreets;

jQuery(document).ready(function() {


	if($('#map').length != 0){
		/*console.log($('#map').length);*/


		googlesatelite =  L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
		    maxZoom: 20,
		    subdomains:['mt0','mt1','mt2','mt3']
		});

		googlestreets = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{
		    maxZoom: 20,
		    /*subdomains:['mt0','mt1','mt2','mt3']*/
		});


	
	    mymap = L.map('map', {
	    	dragging: !L.Browser.mobile, tap: !L.Browser.mobile,
	    	layers: [googlesatelite, googlestreets]
	    	}).setView([56.946285, 24.105078], 5);



	    var baseMaps = {
		    
		    "Satelite": googlesatelite,
		    "Map": googlestreets,
		};

		var overlayMaps = {
		    /*"Cities": cities*/
		};

	    L.control.layers(baseMaps, overlayMaps).addTo(mymap);



		/*L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
			maxZoom: 18,
			attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
				'<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
				'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
			id: 'mapbox/streets-v11',
			tileSize: 512,
			zoomOffset: -1
		}).addTo(mymap);*/

		/*var googlestreets =  L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
		    maxZoom: 20,
		    subdomains:['mt0','mt1','mt2','mt3']
		});

		var googlesatelite = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{
		    maxZoom: 20,
		    subdomains:['mt0','mt1','mt2','mt3']
		});

		L.control.layers(googlestreets, googlesatelite).addTo(mymap);*/

		 

		mymap.scrollWheelZoom.disable();

		var zoomTimer;

		// on entering the map we're starting a timer to
		// 3 seconds after which we'll enable scroll-zooming
		mymap.on('mouseover', function() {
			zoomTimer = setTimeout(function(){
				mymap.scrollWheelZoom.enable();
		    }, 3000);
		});

		// on leaving the map we're disarming not yet triggered timers
		// and disabling scrolling
		mymap.on('mouseout', function() {
		    clearTimeout(zoomTimer);
		    mymap.scrollWheelZoom.disable();
		});

		if(trigger_tree_find) {
			/*console.log('blu');*/

			setTimeout(function(){ 
				jQuery('.search-submit-f').trigger('click');
			}, 6000);	
		}
	}

	jQuery('.single-post .wp-block-group__inner-container').each(function(index, value) {
	 /* console.log(jQuery(this));
	  console.log(jQuery(this).find('.wp-block-image ').length);*/
	  jQuery( '<div class="custom-gal-nav"><span class="changeable-o">1</span> of '+jQuery(this).find('.wp-block-image ').length+'</p></div>' ).insertAfter( jQuery(this) );

	});
	jQuery('.single-post ul.blocks-gallery-grid').each(function(index, value) {
	  /*console.log(jQuery(this));
	  console.log(jQuery(this).find('.blocks-gallery-item ').length);*/
	  jQuery( '<div class="custom-gal-nav"><span class="changeable-o">1</span> of '+jQuery(this).find('.blocks-gallery-item ').length+'</p></div>' ).insertAfter( jQuery(this).parent() );

	});
	jQuery('.single-post .wp-block-group__inner-container, .single-post ul.blocks-gallery-grid').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	    var i = (currentSlide ? currentSlide : 0) + 1;
	   /* console.log(i);*/
	    jQuery('.changeable-o').text(i);
	});

	jQuery('.single-post .wp-block-group__inner-container, .single-post ul.blocks-gallery-grid').slick({
		adaptiveHeight: true
	});

	


	/*console.log(localStorage.getItem('business'));*/
	var businesschecker = localStorage.getItem('business');
	if(businesschecker == 'false'){
		businesschecker = false;
	}
	/*console.log(businesschecker);*/

	if(jQuery('body').hasClass('page-id-59') || businesschecker && ! jQuery('body').hasClass('page-template-page-afforestation')){
		/*console.log('e');*/
		jQuery('#switch-2').prop( "checked", true );
		jQuery('#switch').prop( "checked", true );
            jQuery('.person-type-block').hide();
            jQuery('.company-type-block').show();
            jQuery('.person-type-block.company-type-block').show();

            jQuery('body').addClass('business-pag');


            jQuery('.indidviduals-textual').removeClass('active');
            jQuery('.business-textual').addClass('active');

             jQuery('.collapsable-block-row-company').show(); 
             if(jQuery('.collapsable-block-row:visible').length <= 4 ) {
            	jQuery('.load-more-divo').hide();
            } else { jQuery('.load-more-divo').show(); }


             jQuery('.collapsable-block-row-company:gt(3)').hide();
            jQuery('.collapsable-block-row-individual').hide();
            jQuery('.load-more-divo').show();

            /*console.log(jQuery('.collapsable-block-row:visible').length);*/
	}

	if(jQuery('.collapsable-block-row:visible').length <= 4) {
            	jQuery('.load-more-divo').hide();
            } else { jQuery('.load-more-divo').show(); }

            if(jQuery('body').hasClass('page-id-59') || businesschecker){
            	jQuery('.load-more-divo').show();
            }
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery('footer .options').click(function(e) {
		jQuery('.cookies_original_position').hide();
	});

	jQuery('.contact-form-open').click(function(e) {
		e.preventDefault();
		jQuery('#form-overlay').fadeIn();
		//console.log('click');
		jQuery('html, body').css('overflow-y', 'hidden');
	});

	jQuery('.close-popup').click(function(e) {
		e.preventDefault();
		jQuery('#form-overlay').fadeOut();
		jQuery('html, body').css('overflow-y', 'auto');
	});

	jQuery('.read-more-link').click(function(e) {
		e.preventDefault();
		if(!jQuery(this).hasClass('readfull')){
			jQuery(this).addClass('readfull');
			jQuery(this).text(readlessstring);
			jQuery('.absolute-fade').fadeOut('slow');
			jQuery(this).parent().find('.hided').fadeIn('slow');
		} else {
			jQuery(this).removeClass('readfull');
			jQuery(this).text(readmortestring);
			jQuery('.absolute-fade').fadeIn('slow');
			jQuery(this).parent().find('.hided').fadeOut('slow');
		}
	});

	jQuery('.collapsable-block-row').click(function(e) {
		e.preventDefault();
		//console.log(jQuery(this));
		
		if(!jQuery(this).hasClass('active')){
			jQuery('.collapsable-block-row').removeClass('active');
			jQuery(this).addClass('active');
		} else {
			jQuery(this).removeClass('active');
		}
	});

	jQuery('.burger, .overlay').click(function(){
	  jQuery('.burger').toggleClass('clicked');
	  jQuery('.overlay').toggleClass('show');
	  jQuery('nav').toggleClass('show');
	  jQuery('#menu-popup-mob').toggleClass('show');
	  jQuery('body').toggleClass('overflow');
	});

	jQuery('.load-more-divo').click(function(){
	  if(jQuery('body').hasClass('business-pag')) {
	  	jQuery('.collapsable-block-row-company').show();
	  	jQuery('.load-more-divo').hide();
	  }
	});

	jQuery('#switch').change(function() {
		
        if(this.checked) {
        	localStorage.setItem('business',true);
            //console.log('checked');
            jQuery('#switch-2').prop( "checked", true );


            jQuery('.person-type-block').hide();
            jQuery('.company-type-block').show();
            jQuery('.person-type-block.company-type-block').show();

            jQuery('body').addClass('business-pag');


            jQuery('.indidviduals-textual').removeClass('active');
            jQuery('.business-textual').addClass('active');

             jQuery('.collapsable-block-row-company').show(); 
             if(jQuery('.collapsable-block-row:visible').length <= 4 ) {
            	jQuery('.load-more-divo').hide();
            } else { jQuery('.load-more-divo').show(); }


             jQuery('.collapsable-block-row-company:gt(3)').hide();
            jQuery('.collapsable-block-row-individual').hide();

            //console.log(jQuery('.collapsable-block-row:visible').length);

            window.history.pushState( {} , '', site_url_main +'/business/' );
            
        } else {
        	localStorage.setItem('business',false);
        	jQuery('#switch-2').prop( "checked", false );
        	//console.log('not checked');

        	jQuery('.person-type-block').show();
            jQuery('.company-type-block').hide();
            jQuery('.person-type-block.company-type-block').show();

            jQuery('body').removeClass('business-pag');


            jQuery('.indidviduals-textual').addClass('active');
            jQuery('.business-textual').removeClass('active');

             jQuery('.collapsable-block-row-company').hide();
            jQuery('.collapsable-block-row-individual').show();

            //console.log(jQuery('.collapsable-block-row:visible').length);

            if(jQuery('.collapsable-block-row:visible').length <= 4 ) {
            	jQuery('.load-more-divo').hide();
            } else { jQuery('.load-more-divo').show(); }


            window.history.pushState( {} , '', site_url_main +'/' );
        }
        
    });

    jQuery('#switch-2').change(function() {
    	
        if(this.checked) {

        	jQuery('html,body').scrollTop(0);
        	jQuery('.custom-switcher-between').css('bottom', '20px');
        	localStorage.setItem('business',true);
        	jQuery('#switch').prop( "checked", true );
            //console.log('checked');

            jQuery('.person-type-block').hide();
            jQuery('.company-type-block').show();
            jQuery('.person-type-block.company-type-block').show();

            jQuery('body').addClass('business-pag');

            jQuery('.indidviduals-textual').removeClass('active');
            jQuery('.business-textual').addClass('active');

             jQuery('.collapsable-block-row-company').show(); 
             if(jQuery('.collapsable-block-row:visible').length <= 4 ) {
            	jQuery('.load-more-divo').hide();
            } else { jQuery('.load-more-divo').show(); }


             jQuery('.collapsable-block-row-company:gt(3)').hide();
            jQuery('.collapsable-block-row-individual').hide();

            //console.log(jQuery('.collapsable-block-row:visible').length);

            window.history.pushState( {} , '', site_url_main +'/business/' );

            
        } else {
        	$('html,body').scrollTop(0);
        	jQuery('.custom-switcher-between').css('bottom', '20px');
        	localStorage.setItem('business',false);
        	jQuery('#switch').prop( "checked", false );
        	//console.log('not checked');

        	jQuery('.person-type-block').show();
            jQuery('.company-type-block').hide();
            jQuery('.person-type-block.company-type-block').show();

            jQuery('body').removeClass('business-pag');

            jQuery('.indidviduals-textual').addClass('active');
            jQuery('.business-textual').removeClass('active');

             jQuery('.collapsable-block-row-company').hide();
            jQuery('.collapsable-block-row-individual').show();

            //console.log(jQuery('.collapsable-block-row:visible').length);

            if(jQuery('.collapsable-block-row:visible').length <= 4 ) {
            	jQuery('.load-more-divo').hide();
            } else { jQuery('.load-more-divo').show(); }


            window.history.pushState( {} , '', site_url_main +'/' );
        }
        
    });

    jQuery('#pay_company').keyup( function(e) {
    	//console.log(jQuery(this).val().length);
    	if(jQuery(this).val().length>1) {
    		jQuery('.company-fields-additional').show();
    	} else {
    		jQuery('.company-fields-additional').hide();
    	}
	  // your code
	});

    jQuery('#pay_company_reg_number_vat').change( function(e) {

    	//console.log(e);
    	var paramArr = new Array();
		paramArr.push( {name:'vat_number', value:jQuery(this).val()} );
	    paramArr.push( {name:'access_key', value:'5aed134271aa9dead2f012f290465a05'} );
	    paramArr.push( {name:'format', value:'1'} );

    	jQuery.ajax({
	        url : 'http://apilayer.net/api/validate',
	        type : 'get',
	        data : $.param(paramArr),
	        success : function( response ) {   
	        	//console.log(response);

	        	if(response.valid && response.country_code != 'LV') {
	        		zerovat = true;
	        		//console.log('zerovat '+zerovat);
	        	} else {
	        		zerovat = false;
	        		//console.log('zerovat '+zerovat);
	        	}

	        	recalculateProdPrice();
	        }
	    });
			    

			    
    });

	

    jQuery('.mobile-switch-versions .indidviduals-textual').click(function(e) {
    	localStorage.setItem('business',false);
    	jQuery(this).addClass('active');
    	jQuery('.mobile-switch-versions .business-textual').removeClass('active');

    	jQuery('#switch').prop( "checked", false );
    	jQuery('#switch-2').prop( "checked", false );

    	jQuery('.person-type-block').show();
            jQuery('.company-type-block').hide();
            jQuery('.person-type-block.company-type-block').show();

            jQuery('body').removeClass('business-pag');

            jQuery('.indidviduals-textual').addClass('active');
            jQuery('.business-textual').removeClass('active');


            jQuery('.collapsable-block-row-company').hide();
            jQuery('.collapsable-block-row-individual').show();

            //console.log(jQuery('.collapsable-block-row:visible').length);

            if(jQuery('.collapsable-block-row:visible').length <= 4 ) {
            	jQuery('.load-more-divo').hide();
            } else { jQuery('.load-more-divo').show(); }

            window.history.pushState( {} , '', site_url_main +'/' );
    });

    jQuery('.mobile-switch-versions .business-textual').click(function(e) {
    	localStorage.setItem('business',true);
    	jQuery(this).addClass('active');
    	jQuery('.mobile-switch-versions .individuals-textual').removeClass('active');

    	jQuery('#switch').prop( "checked", true );
    	jQuery('#switch-2').prop( "checked", true );

    	 jQuery('.person-type-block').hide();
            jQuery('.company-type-block').show();
            jQuery('.person-type-block.company-type-block').show();

            jQuery('body').addClass('business-pag');

            jQuery('.indidviduals-textual').removeClass('active');
            jQuery('.business-textual').addClass('active');

             jQuery('.collapsable-block-row-company').show(); 
              if(jQuery('.collapsable-block-row:visible').length <= 4 ) {
            	jQuery('.load-more-divo').hide();
            } else { jQuery('.load-more-divo').show(); }


             jQuery('.collapsable-block-row-company:gt(3)').hide();
            jQuery('.collapsable-block-row-individual').hide();

            //console.log(jQuery('.collapsable-block-row:visible').length);

            window.history.pushState( {} , '', site_url_main +'/business/' );

          
    });

    jQuery('.add-to-cart, .plant-a-tree-btn').click(function(e) {
		e.preventDefault();
		//console.log(jQuery(this));
		jQuery('.cart-popup').css('right', '0px');

		if(jQuery(window).width() <= 1024) {
			jQuery('.cart-popup').css('right', '0px');
			jQuery('.cart-popup').css('width', '100%');
		}
		
	});

	jQuery('.close-cart').click(function(e) {
		e.preventDefault();
		//console.log(jQuery(this));
		jQuery('.cart-popup').css('right', '-350px');
		jQuery('.cart-popup').css('width', '350px');
		jQuery('.step-2-cart').hide();
		jQuery('.step-3-cart').hide();
		jQuery('.step-1-cart').show();
	});

	jQuery('.shopify-buy-frame ').click(function(e) {
		e.preventDefault();
		//console.log(jQuery(this));
		jQuery('.cart-popup').css('right', '0px');

		if(jQuery(window).width() <= 1024) {
			jQuery('.cart-popup').css('right', '0px');
			jQuery('.cart-popup').css('width', '100%');
		}
		
	});

	jQuery('.scroll-to-gall').click(function(e) {
		e.preventDefault();
		//console.log(e);
		//jQuery('html,body').scrollTop(0);
		jQuery('html, body').animate({
	        scrollTop: jQuery(".gallery_block").offset().top-100
	    }, 2000);
	});

	jQuery('.learn-more-bttttn-bus').click(function(e) {
		e.preventDefault();
		//console.log(e);
		//jQuery('html,body').scrollTop(0);
		jQuery('html, body').animate({
	        scrollTop: jQuery(".first-block-company-type.company-type-block.custom-front-blocks.gray-bg").offset().top-100
	    }, 2000);
	});

	jQuery('.shopify-buy__btn.shopify-buy__btn--cart-checkout').click(function(e) {
		e.preventDefault();
		jQuery('.step-2-cart').show();
		jQuery('.step-1-cart').hide();
		jQuery('.cart-popup').css('width', '100%');
		
	});

	// Handle real-time validation errors from the card Element.
	cardElement.on('change', function(event) {
	  //console.log(event);
	  if (event.error) {
	    //console.log(event.error.message);
	    carddata = false;
	    jQuery('.error-text').text(event.error.message);
	  }/* else {
	    console.log('viss ok');
	    carddata = true;
	  }*/
	  if (event.complete) {
	    
	    carddata = true;
	  } else {
	  	carddata = false;
	  }

	});

	jQuery('.shopify-buy__quantity-decrement').click(function(e) {
		//console.log('decr');
		if(parseInt(jQuery('input.shopify-buy__quantity').val()) < 2) {

		} else {
			var decr = parseInt(jQuery('input.shopify-buy__quantity').val())-1;
			jQuery('input.shopify-buy__quantity').val(decr);
		}
		recalculateProdPrice();
	});

	jQuery('.shopify-buy__quantity-increment').click(function(e) {
		//console.log('incr');
		var inc = parseInt(jQuery('input.shopify-buy__quantity').val())+1;
		jQuery('input.shopify-buy__quantity').val(inc);
		recalculateProdPrice();
	});

	jQuery('input.shopify-buy__quantity').change(function(e) {
		//console.log(parseInt(jQuery(this).val()));
		if(parseInt(jQuery(this).val()) < 0) {
			jQuery(this).val(1);
		}
		recalculateProdPrice();
	});

	jQuery('input.payment_choose').change(function(e) {
		//console.log(jQuery(this).val());
		if(jQuery(this).val() == 'card') {
			jQuery('.card-div-to-show').show();
			jQuery('#paypal-button').hide();
			jQuery('.pay-btn').show();
		} else {
			jQuery('.card-div-to-show').hide();
			jQuery('#paypal-button').show();
			jQuery('.pay-btn').hide();
		}
		
	});

	jQuery('.paypal-button-overlay-cantclick').click(function(e) {
		//console.log(e);
		e.preventDefault();
		//jQuery("#paypal-button").trigger('click');
	});

	jQuery('#checkout-form input, #checkout-form select, #checkout-form textarea, #checkout-form-2 input').change(function(e) {
		//console.log(e);

		 $("#checkout-form").validate({
		  debug: true
		})
		 $("#checkout-form-2").validate({
		  debug: true
		})
		//console.log(jQuery("#checkout-form").valid(), jQuery("#checkout-form-2").valid());

		if(jQuery("#checkout-form").valid() && jQuery("#checkout-form-2").valid() && jQuery('#policy_check').is(":checked")){
			canpaypaypal = true;
			jQuery('.paypal-button-overlay-cantclick').hide();
		} else {
			canpaypaypal = false;
			jQuery('.paypal-button-overlay-cantclick').show();
		}
		//e.preventDefault();
	});

	jQuery('.apply-discount').click(function(e) {

		e.preventDefault();
		var paramArr = new Array();
		paramArr.push( {name:'checkCouponValidity', value:true} );
	    paramArr.push( {name:'action', value:'checkCouponValidity'} );

	    paramArr.push( {name:'value', value:jQuery('#discount-text').val()} );

		jQuery.ajax({
	        url : ajaxurl,
	        type : 'post',
	        data : $.param(paramArr),
	        success : function( response ) {    
	        	response = jQuery.parseJSON( response );  
	        	//console.log(response);
	        	if(response.coupon_valid && response.coupon_type == 'full discount') {
	        		jQuery('.pay-btn, #paypal-button-main, .checkout-window, .transaction-paragraph, .hide-if-coupon').hide();
	        		jQuery('.continue-btn').show();
	        	} else {
	        		jQuery('.pay-btn, #paypal-button-main, .checkout-window, .transaction-paragraph, .hide-if-coupon').show();
	        		jQuery('.continue-btn').hide();
	        	}

	        	if(response.coupon_valid && response.coupon_type == 'percent discount') {
	        		recalculateProdPrice(response.coupon_percent_amount);
	        	}

	        	if(response.coupon_valid && response.coupon_type == 'concrete summ discount') {
	        		recalculateProdPrice(false, response.minus_amount);
	        	}
	        }
	    });

	});



	var disablebtn = false;

	recalculateProdPrice();

	jQuery('.continue-btn').click(function(e) {
		e.preventDefault();
		//console.log('contclic');
		if(jQuery("#checkout-form").valid() && jQuery("#checkout-form-2").valid() && jQuery('#policy_check').is(":checked") ){
			//console.log('create discount order');
			jQuery('.step-2-cart').fadeOut('slow', function(){
		    	// insert loading anim
		    	jQuery('.loader-block').show();
		    });
			payAjax('discount', 'mccann');
		}
	});

	jQuery('.pay-btn').click(function(e) {
		e.preventDefault();
	    
	    /*jQuery('.step-2-cart').fadeOut('slow', function(){
	    	 jQuery('.step-3-cart').fadeIn('slow');
	    });*/

	    

	    $("#checkout-form").validate({
		  debug: true
		})
		 $("#checkout-form-2").validate({
		  debug: true
		})
		//console.log(jQuery("#checkout-form").valid(), jQuery("#checkout-form-2").valid());
	   

	   


	    	 /*stripe.createToken(cardElement).then(function(result) {
			    if (result.error) {
			      console.log(result, 'ir sis');
			    } else {
			      // Send the token to your server.
			      console.log(result, 'vai ir sis');
			    }
			  });*/

			  //policy_check
			if(jQuery("#checkout-form").valid() && jQuery("#checkout-form-2").valid() && carddata && jQuery('#policy_check').is(":checked") ){

				jQuery('.step-2-cart').fadeOut('slow', function(){
			    	// insert loading anim
			    });

				if(!disablebtn) {
					disablebtn = true;
					jQuery('.loader-block').show();

					var paramArr = new Array();
					paramArr.push( {name:'getclientSecret', value:true} );
				    paramArr.push( {name:'action', value:'clientSecretret'} );

				    paramArr.push( {name:'amount', value:totalsumvar} );

					jQuery.ajax({
				        url : ajaxurl,
				        type : 'post',
				        data : $.param(paramArr),
				        success : function( response ) {        
				           
				           clientSecret = '';

				           response = jQuery.parseJSON( response );     
				           /*console.log(response);  
				           console.log(response.client_secret);*/

					    	stripe.confirmCardPayment(response.client_secret, {
							    payment_method: {
							      card: cardElement,
							      billing_details: {
							        name: ''+jQuery('#pay_firstname').val()+' '+jQuery('#pay_surname').val()
							      }
							    }
							  }).then(function(result) {
							  	
							  	disablebtn = false;
							    if (result.error) {
							      // Show error to your customer (e.g., insufficient funds)
							      //console.log(result.error.message);
							      jQuery('.error-text').text(result.error.message);
							    } else {
							    	//console.log(result);
							      // The payment has been processed!
							      if (result.paymentIntent.status === 'succeeded') {

							        // Show a success message to your customer
							        // There's a risk of the customer closing the window before callback
							        // execution. Set up a webhook or plugin to listen for the
							        // payment_intent.succeeded event that handles any business critical
							        // post-payment actions.

							        payAjax('stripe', result.paymentIntent.id);
							      }
							    }
							});
				        }
					});

					

				}
			}
	});

										/*jQuery('.btn_share').click(function(e) {
								           	
								           	if(jQuery(this).hasClass('active-share')){
								           		jQuery('.share_cont').hide();
								           		jQuery(this).removeClass('active-share');
								           	} else {
								           		jQuery('.share_cont').show();
								           		jQuery(this).addClass('active-share');
								           	}
								           });*/

	jQuery('#custom-tree-search').submit(function(e) {
		e.preventDefault();
		jQuery('.search-submit-f').trigger('click');
	});

	jQuery('.search-submit-f').click(function(e) {
		e.preventDefault();
	    var paramArr = new Array();
	    paramArr.push( {name:'find_tree', value:true} );
	    paramArr.push( {name:'action', value:'find_tree'} );
	    paramArr.push( {name:'orderid', value:jQuery('#search-tree').val()} );
    
		    jQuery.ajax({
		        url : ajaxurl,
		        type : 'post',
		        data : $.param(paramArr),
		        success : function( response ) {   
		        	response = jQuery.parseJSON( response );   
		        	console.log(response); 
		        	console.log(JSON.parse(response[0].locdat[0].location_polygon));
		        	

		        	jQuery('.violet-block').addClass('searched-found');
		        	jQuery('.violet-block .textual-block h4').text(certtidstring+' '+response[0].cert_number);
		        	jQuery('.violet-block .textual-block p').text(plantedstring+' '+response[0].planted_trees+' '+treestring);
					//deleteMarkers();
					var markersretrieve = response[0].locations;
					var zii = 0;
		           	jQuery.each(markersretrieve, function(i, item) {
		           		if(zii == 0) {
		           			console.log(item[0], item[1]);

		           			//if(item[0] == "57.773" && item[1] == "25.488") {
		           			 
		           			 	 mymap.removeLayer(googlesatelite);
		           			 	 mymap.addLayer(googlestreets);
			           			 mymap.flyTo([parseFloat(item[0]), parseFloat(item[1])], 7, {"animate": true, duration: 3});

			           			 setTimeout(function(){
									 mymap.flyTo([parseFloat(item[0]), parseFloat(item[1])], 14), {"animate": true, duration: 3};
									 

		           			 	     setTimeout(function(){
		           			 	     	mymap.removeLayer(googlestreets);
			           			 	 	mymap.addLayer(googlesatelite);
				           			 	 var polygon = L.polygon(JSON.parse(response[0].locdat[0].location_polygon)).addTo(mymap);

				           			 	 /*var greenIcon = L.icon({
											    iconUrl: site_url +'koks.png',
											    

											    iconSize:     [150, 150], // size of the icon
											    
											    iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
											    
											    popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
											});

				           			 	 	L.marker([57.771, 25.491], {icon: greenIcon}).addTo(mymap);*/

				           			 	 	var icon = L.divIcon({
											        className: 'custom-div-icon',
											        html: "<div class='marker-pin'><span class='tree-count-in-find'>"+response[0].planted_trees+"</span></div>",
											        iconSize: [150, 150],
											        iconAnchor: [15, 42]
											    });

				           			 	 	mymap.removeLayer(icon);
											    
											L.marker([parseFloat(item[0]), parseFloat(item[1])], { icon: icon }).addTo(mymap);

			           			 	  }, 3000);
							    }, 1000);
		           			

		           			

		           			//map.panTo(  { lat: parseFloat(item[0]), lng: parseFloat(item[1]) } );
		           			//map.setZoom(11);
		           		}
					   	/*var myLatlng =  { lat: parseFloat(item[0]), lng: parseFloat(item[1]) } // new google.maps.LatLng(item[0],item[2]);
						addMarker(myLatlng);*/
		              	zii++;
					});
		        }
		});
	});
}); 


var totaltreeecount = 1;

function recalculateProdPrice(discount, concrete_sum_discount) {
	//console.log(jQuery('.product-price .price').attr('data-price'));

	//console.log(jQuery('.product-price .price').attr('data-price')*parseInt(jQuery('input.shopify-buy__quantity').val()));


	if(!zerovat) {
		var totalsum = jQuery('.product-price .price').attr('data-price')*parseInt(jQuery('input.shopify-buy__quantity').val());
		if(discount) {
			var discount = totalsum*parseFloat(discount);
			totalsum = totalsum - discount;
		}
		if(concrete_sum_discount) {
			console.log(discount);
			console.log(totalsum, parseInt(concrete_sum_discount));
			var totalsumminus = totalsum - parseInt(concrete_sum_discount);
			console.log(totalsumminus);
			totalsum = totalsumminus;
			//console.log(totalsumvar, parseInt(concrete_sum_discount));
		}

		jQuery('.product-price .price').text('€ '+totalsum);

		jQuery('.shopify-buy__cart__subtotal__price').text('€ '+totalsum);
		jQuery('.tax-value, .tax-name').show();
		jQuery('.shopify-buy__cart__subtotal__price.subtotal-custtm').text('€ '+(totalsum-(totalsum*0.21)).toFixed(1));
		jQuery('.tax-value').text('€ '+(totalsum*0.21).toFixed(1));
		jQuery('.total-value').text('€ '+totalsum);
		

		totalsumvar = totalsum;

		totaltreeecount = parseInt(jQuery('input.shopify-buy__quantity').val());

	} else {
		var totalsum = jQuery('.product-price .price').attr('data-price')*parseInt(jQuery('input.shopify-buy__quantity').val());
		if(discount) {
			var discount = totalsum*parseFloat(discount);
			totalsum = totalsum - discount;
		}
		if(concrete_sum_discount) {
			console.log(discount);
			console.log(totalsum, parseInt(concrete_sum_discount));
			console.log(totalsumminus);
			var totalsumminus = totalsum - parseInt(concrete_sum_discount);
			totalsum = totalsumminus;
			//console.log(totalsumvar, parseInt(concrete_sum_discount));
		}

		jQuery('.product-price .price').text('€ '+totalsum);

		jQuery('.shopify-buy__cart__subtotal__price').text('€ '+totalsum);
		jQuery('.tax-value, .tax-name').hide();
		jQuery('.shopify-buy__cart__subtotal__price.subtotal-custtm').text('€ '+(totalsum-(totalsum*0.0)).toFixed(1));
		jQuery('.tax-value').text('€ '+(totalsum*0.0).toFixed(1));
		jQuery('.total-value').text('€ '+totalsum);



		totalsumvar = totalsum;

		totalsumvar = totalsumvar-(totalsum*0.21);
		
		totalsumvar = (totalsumvar).toFixed(1);
		jQuery('.shopify-buy__cart__subtotal__price.subtotal-custtm, .total-value').text('€ '+totalsumvar);
		totaltreeecount = parseInt(jQuery('input.shopify-buy__quantity').val());
	}


				
			    

				 

				// return false;
}




// Adds a marker to the map and push to the array.
function addMarker(location) {
	var sizeX = 120;
	var sizeY = 120;
	var icon = {
	        url: site_url+'assets/images/marker.svg',
	        size: new google.maps.Size(sizeX, sizeY),
	        origin: new google.maps.Point(0, 0),
	        anchor: new google.maps.Point(sizeX/2, sizeY/2)
	};
	const marker = new google.maps.Marker({
		position: location,
		map: map,
		title: '',
		icon: icon
	});
	markers.push(marker);
}

// Sets the map on all markers in the array.
function setMapOnAll(map) {
  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(map);
  }
}

// Removes the markers from the map, but keeps them in the array.
function clearMarkers() {
  setMapOnAll(null);
}

// Shows any markers currently in the array.
function showMarkers() {
  setMapOnAll(map);
}

// Deletes all markers in the array by removing references to them.
function deleteMarkers() {
  clearMarkers();
  markers = [];
}

function payAjax(type, payreff) {
	if(jQuery('#subscribe_check').is(":checked") == true ) {
    	jQuery('#subscribe_check').attr('value', 'on');
    } else {
    	jQuery('#subscribe_check').attr('value', 'off');
    }

    var paramArr = new Array();
		paramArr.push( {name:'pay_cart', value:true} );
	paramArr.push( {name:'action', value:'pay_cart'} );

	paramArr.push( {name:'firstname', value:jQuery('#pay_firstname').val()} );
	paramArr.push( {name:'surname', value:jQuery('#pay_surname').val()} );
	paramArr.push( {name:'address', value:jQuery('#pay_address').val()} );
	paramArr.push( {name:'email', value:jQuery('#pay_email').val()} );
	paramArr.push( {name:'pay_company', value:jQuery('#pay_company').val()} );
	paramArr.push( {name:'pay_company_reg_number', value:jQuery('#pay_company_reg_number').val()} );
	paramArr.push( {name:'pay_company_reg_number_vat', value:jQuery('#pay_company_reg_number_vat').val()} );
	paramArr.push( {name:'subscribe_check', value:jQuery('#subscribe_check').val()} );
	paramArr.push( {name:'amount', value:totalsumvar} );
	paramArr.push( {name:'treecount', value:totaltreeecount} );
	paramArr.push( {name:'paymant_reff', value:payreff} );
	paramArr.push( {name:'vat_checked', value:zerovat} );
	//console.log('payajaxcheck');

    jQuery.ajax({
        url : ajaxurl,
        type : 'post',
        data : $.param(paramArr),
        success : function( response ) {   
       	 	jQuery('.loader-block').fadeOut('slow');
				jQuery('.step-3-cart').fadeIn('slow');     
           //console.log(response);  
           response = jQuery.parseJSON( response );   
           /*jQuery('.step-2-cart').fadeOut('slow', function(){
		    	 jQuery('.step-3-cart').fadeIn('slow');
		    });*/
           jQuery('.firstname-to-change').text(jQuery('#pay_firstname').val());
           jQuery('.cert-number').text(response.return_id);
           jQuery('.cert-img').attr('src', site_url_main+'/certs/cert-'+response.return_id+'.pdf');
           jQuery('.download-btn').attr('href', site_url_main+'/certs/cert-'+response.return_id+'.pdf');
           jQuery('.trees_line .trees').text(response.plantedtreecount);

           jQuery('.download-btn').click(function(e) {
           	//e.stopPropagation();
           	//return true;
           	//console.log(e);
           	window.open(site_url_main+'/certs/cert-'+response.return_id+'.pdf', '_blank'); 
           });	

           jQuery('.item.fb').attr('href', 'https://www.facebook.com/sharer.php?u='+site_url_main+'/find-your-tree?tree_id='+response.return_id+'');
           jQuery('.item.tw').attr('href', 'https://twitter.com/share?url='+site_url_main+'/find-your-tree?tree_id='+response.return_id+'');

           jQuery('.item.fb').click(function(e) {
           	//console.log(e);
           	window.open('https://www.facebook.com/sharer.php?u='+site_url_main+'/find-a-tree?tree_id='+response.return_id+'', '_blank'); 
           });	

           jQuery('.item.tw').click(function(e) {
           	//console.log(e);
           	window.open('https://twitter.com/share?url='+site_url_main+'/find-a-tree?tree_id='+response.return_id+'', '_blank'); 
           });	

           jQuery('.btn_share').click(function(e) {
           	
           	if(jQuery(this).hasClass('active-share')){
           		jQuery('.share_cont').hide();
           		jQuery(this).removeClass('active-share');
           	} else {
           		jQuery('.share_cont').show();
           		jQuery(this).addClass('active-share');
           	}
           });
           
        }
	});
}